module.exports = __webpack_public_path__ + "static/images/callout_3.c73ef6d2c17abdc4631b1e72e89862c3.jpg";